import clsx from "clsx";
import { LoaderCircle, Search } from "lucide-react";
import { FC, MouseEventHandler, ReactNode } from "react";

type Props = {
  children: ReactNode;
  startIcon?: ReactNode;
  isLoading?: boolean;
  variant?: "secondary" | "neutral" | "white";
  rounded?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  fullWidth?: boolean;
};

const Button: FC<Props> = ({
  children,
  startIcon,
  isLoading = false,
  variant = "secondary",
  rounded = false,
  onClick,
  fullWidth,
  disabled = false,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={isLoading || disabled}
      className={clsx(
        `text-base font-medium font-switzer py-3 md:py-4 px-5 md:px-6 flex-shrink-0 h-12`,
        variant === "secondary" &&
          "bg-sleap-purple-300 hover:bg-sleap-gray-950 text-white",
        variant === "neutral" &&
          "bg-sleap-gray-200 hover:bg-sleap-gray-400 text-sleap-gray-950",
        variant === "white" &&
          "bg-white hover:bg-opacity-80 text-sleap-gray-950 dark:bg-sleap-gray-950 dark:text-white dark:hover:bg-opacity-80",
        rounded ? "rounded-full" : "rounded-full",
        fullWidth ? "w-full" : "w-auto"
      )}
    >
      {isLoading ? (
        <div className="w-full flex justify-center items-center h-6">
          <span className="!h-9 !w-9 flex items-center justify-center">
            <LoaderCircle className="text-white animate-spin" />
          </span>
        </div>
      ) : (
        <span className="flex gap-1.5">
          {startIcon}
          {children}
        </span>
      )}
    </button>
  );
};

export default Button;
